import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getRemoteConfig } from 'firebase/remote-config';
import { firebaseConfigForMode, resolveFirebaseMode } from './firebaseProjects';

// WHICH PROJECT THIS BUILD AUTHENTICATES AGAINST — see firebaseProjects.ts.
// The literal that used to sit here named `salesguru-86316` unconditionally,
// which is why dev accounts and paying customers' users shared one identity
// pool: there was no mechanism to vary it, in a codebase that already varies a
// dozen other values per tenant at build time.
const firebaseMode = resolveFirebaseMode(process.env.REACT_APP_FIREBASE_MODE);
const firebaseConfig = firebaseConfigForMode(firebaseMode);

console.log('[Firebase] Initializing Firebase app with project:', firebaseConfig.projectId);
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Set persistence to local (default) to maintain auth state across page refreshes
setPersistence(auth, browserLocalPersistence).then(() => {
  console.log('[Firebase] Auth persistence set to LOCAL');
}).catch((error) => {
  console.error('[Firebase] Error setting auth persistence:', error);
});

// Log current auth state
// auth.onAuthStateChanged((user) => {
//   console.log('[Firebase] Global auth state changed:', {
//     isLoggedIn: !!user,
//     email: user?.email || 'none',
//     uid: user?.uid || 'none',
//     timestamp: new Date().toISOString()
//   });
// });

export const remoteConfig = getRemoteConfig(app);

// Windows installer URL is served from Remote Config (WINDOWS_DOWNLOAD_URL) so a new
// installer can ship without redeploying the portal. The default below is the fallback
// when the fetch fails or the parameter is unset — a stale link beats a broken button.
export const WINDOWS_DOWNLOAD_URL_KEY = 'WINDOWS_DOWNLOAD_URL';
export const WINDOWS_DOWNLOAD_URL_FALLBACK =
  'https://apps.apexialabs.ai/windows';

// The macOS app ships through the App Store, so its link is stable and needs
// no Remote Config indirection — new builds keep the same store URL.
export const MAC_APP_STORE_URL = 'https://apps.apple.com/us/app/apexia-labs/id6760661143';

remoteConfig.settings.minimumFetchIntervalMillis = 60 * 60 * 1000; // 1 hour
remoteConfig.defaultConfig = {
  [WINDOWS_DOWNLOAD_URL_KEY]: WINDOWS_DOWNLOAD_URL_FALLBACK,
};

console.log('[Firebase] Firebase initialized successfully');

export default app;
